export default __webpack_public_path__ + "static/media/B-T-HTHRP.838ca76b.svg";